import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { LoginTemplate } from "~/features/auth/LoginTemplate";
import { useAuthStore } from "~/stores/useAuthStore";

const loginSearchSchema = z.object({
  app: z.string().optional(),
  appId: z.coerce.string().optional(),
  lang: z.string().optional(),
  email: z.string().optional(),
  pwd: z.string().optional(),
  // Native（Android のみ）が自動ログイン用に渡す端末識別子（device_id として使用）
  android_original_id: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: loginSearchSchema,
  beforeLoad: () => {
    const token = useAuthStore.getState().token;
    if (token) {
      throw redirect({ to: "/" });
    }
  },
  component: LoginTemplate,
});
